import React from "react";
import PropTypes from "prop-types";

function AddRepresentativeButton({ isLoading, onClick }) {
  if (isLoading) {
    return <button type="button" className="btn btn-primary disabled placeholder btn-sm mb-2 col-2 align-self-start" />;
  }

  return (
    <button
      type="button"
      id="open-add-representative-form"
      name="open-add-representative-form"
      // The list renders straight into a Bootstrap `.card`, which is a stretching flex column, so a
      // button that does not opt out grows to the full card width.
      className="btn btn-primary btn-sm text-nowrap align-self-start"
      onClick={onClick}
    >
      <i className="fa-solid fa-plus cursor-pointer" />
      Add
    </button>
  );
}

AddRepresentativeButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AddRepresentativeButton;
